// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".availability-preview-modal__spinner-block[data-v-53a5844e]{align-items:center;display:grid;justify-items:center;place-items:center}.availability-preview-modal__close[data-v-53a5844e]{position:absolute;right:5px;top:5px}.availability-preview-modal .muted[data-v-53a5844e]{color:#999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
